import React, { Component } from 'react';
import { 
    List,
    ArrayField,
    DateField,
    Datagrid,
    SimpleForm,
    FileInput,
    FileField,
    TextInput,
    Create,
} from 'react-admin';

class RegionalSettingsList extends Component {
    render() {
        return (
            <List title="Regional Settings" exporter={false} {...this.props}>
                <Datagrid>
                    <DateField source="lastUpdate" sortable={true} />
                    <ArrayField source="imports">
                        <Datagrid>
                            <DateField source="date" />
                        </Datagrid>
                    </ArrayField>

                </Datagrid>
            </List>
        );
    }
}
    
class RegionalSettingsCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileAsBase64String: null
        };
    }

    onFileChange(e) {
        console.log(e);
        const reader = new FileReader();
        reader.onload = () => this.onFileRead(reader.result);
        reader.readAsDataURL(e);
    }

    onFileRead(f) {
        this.setState({ fileAsBase64String: f});
    }

    render() {
        return (
            <Create {...this.props}>
                <SimpleForm>
                    <FileInput source="xlsxFile" label="Upload Regional Settings file (.xlsx)" accept=".xlsx" onChange={(evt) => this.onFileChange(evt)}>
                        <FileField source="src" title="title" />
                    </FileInput>
                    <TextInput source="encodedFile" value={this.state.fileAsBase64String}></TextInput>
                </SimpleForm>
            </Create>
        );
    }
}

class RegionalSettingsView extends Component {
    render() {
    return (
        <SimpleForm>
            <FileInput source="csvFile" label="Upload file (.xlsx)" accept=".xlsx">
                <FileField source="src" title="title" />
            </FileInput>
        </SimpleForm>
    );
    }
}

export { RegionalSettingsView, RegionalSettingsList, RegionalSettingsCreate };